<div class="container-fluid">
  <div class="row" style="max-height: 23rem; overflow: hidden">
    <div class="col-md-3 col-lg-2 p-0" style="max-height: 20.25rem; overflow-y: auto">
      <div class="card">
        <div class="card-body p-0" style="height: 20rem !important">
          <ul class="list-group flex-column">
            @for (element of AllQuestions; track element; let i = $index) {
            <li (click)="onQuesSelection(i)" class="list-group-item cursor-pointer" [ngClass]="{ 'bg-color': false }"
              [class.active]="selectedQnIdx === i">
              @if (element.Name != "") {
              <span>{{ element.Name }}</span>
              }
              @if (element.Name == "") {
              <span>{{ element.Label | slice: 0 : 10
                }}{{ element.Label.length > 10 ? "..." : "" }}</span>
              }
            </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-9 ml-sm-auto col-lg-10 px-md-4" style="max-height: 20.25rem; overflow: auto">
      <div class="card--">
        <div class="card-body--" style="height: 20rem !important">
          <ngx-graph [links]="links" [nodes]="nodes" [clusters]="clusters" [layout]="layout" [curve]="curve"
            [draggingEnabled]="draggingEnabled" [panningEnabled]="panningEnabled" [enableZoom]="zoomEnabled"
            [zoomSpeed]="zoomSpeed" [minZoomLevel]="minZoomLevel" [maxZoomLevel]="maxZoomLevel" [panOnZoom]="panOnZoom"
            [autoZoom]="autoZoom" [autoCenter]="autoCenter" [update$]="update$" [center$]="center$"
            [zoomToFit$]="zoomToFit$" (select)="select($event)">
            <ng-template #defsTemplate>
              <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4"
                orient="auto">
                <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
              </svg:marker>
            </ng-template>

            <ng-template #clusterTemplate let-cluster>
              <svg:g class="node cluster">
                <svg:rect rx="5" ry="5" [attr.width]="cluster.dimension.width" [attr.height]="cluster.dimension.height"
                  [attr.fill]="cluster.data.color" />
              </svg:g>
            </ng-template>

            <ng-template #nodeTemplate let-node>
              <svg:g class="node">
                <svg:rect [attr.width]="node.dimension.width" [attr.height]="node.dimension.height"
                  [attr.fill]="node.data.color" />
                <svg:text alignment-baseline="central" [attr.x]="10" [attr.y]="node.dimension.height / 2">
                  {{ node.label | slice: 0 : 10
                  }}{{ node.label.length > 10 ? "..." : "" }}
                </svg:text>
              </svg:g>
            </ng-template>

            <ng-template #linkTemplate let-link>
              <svg:g class="edge">
                <svg:path class="line" stroke-width="2" marker-end="url(#arrow)" [attr.d]="link.line"></svg:path>
                <svg:text class="edge-label" text-anchor="middle">
                  <textPath class="text-path" [attr.href]="'#' + link.id"
                    [style.dominant-baseline]="link.dominantBaseline" startOffset="50%">
                    {{ link.label | slice: 0 : 10
                    }}{{ link.label.length > 10 ? "..." : "" }}
                  </textPath>
                </svg:text>
              </svg:g>
            </ng-template>
          </ngx-graph>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-start justify-content-end p-2 bg-light-subtle">
    <div>
      <input type="submit" class="btn btn-sm btn-primary ms-1" (click)="onImportJson()" [style.visibility]="'hidden'"
        value="Import form" />
      <input type="submit" class="btn btn-sm btn-primary ms-1" (click)="onQuesExtract()" value="Extract Form"
        [style.visibility]="'hidden'" />
      <button (click)="isSection ? SaveMSFConditionalLogic() : SaveConditionalLogic()" class="btn btn-primary ms-2">
        Save
      </button>
    </div>
    @if (apiService?.features?.deleteEntireLogic) {
    <div>
      <button (click)="deleteEntireLogic()" class="btn btn-danger ms-2">
        Delete Entire logic
      </button>
    </div>
    }
  </div>
</div>
<ng-template #sectionDetails let-modal>
  <div class="overflow-auto">
    <form [formGroup]="SectionFlow" (ngSubmit)="onSubmit()">
      <div class="modal-content">
        <div class="modal-header bg-light">
          {{ selectedNode.label | slice: 0 : 10
          }}{{ selectedNode.label.length > 10 ? "..." : "" }}
        </div>
        <div class="modal-body" style="min-height: 35vh">
          <div formArrayName="Rows">
            <button class="btn btn-primary mb-2" type="button" (click)="addRow()">
              <i class="fa-solid fa-plus"></i>&nbsp;Add Row
            </button>
            <table class="table table-bordered border-dark align-middle">
              <tr class="text-center">
                <th class="th-column">Source</th>
                <th class="th-column">Mandatory</th>
                <th class="th-column">Condition</th>
                <th class="th-column">Target</th>
                <th class="th-column">Allow scrore</th>
                <th class="th-column">Score</th>
                <th class="th-column">Dependent Questions</th>
                <th class="th-column">Actions</th>
              </tr>
              @for (row of Rows().controls; track row; let rowIndex = $index) {
              <tbody class="text-center">
                <tr [formGroupName]="rowIndex">
                  <td class="p-1" width="7%">
                    <select class="w-100 form-select" (change)="selectSource(rowIndex)" formControlName="Source">
                      <option value="">Select</option>
                      @for (option of SectionQuestions.Fields; track option) {
                      <option [value]="option.UniqueID">
                        {{ option.Name | slice: 0 : 10
                        }}{{ option.Name.length > 10 ? "..." : "" }}
                      </option>
                      }
                    </select>
                  </td>
                  <td class="p-1" width="3%">
                    <input type="checkbox" class="w-100" formControlName="Mandatory"
                      (change)="changeMandatory(rowIndex)" />
                  </td>
                  <td class="p-1" width="10%">
                    <select (change)="selectCondition(rowIndex)" class="w-100 form-select" formControlName="Condition">
                      <option value="">Select</option>
                      @for (option of row.value.optionValues; track option) {
                      <option [value]="option.OptionText">
                        {{ option.OptionText | slice: 0 : 10
                        }}{{ option.OptionText.length > 10 ? "..." : "" }}
                      </option>
                      }
                    </select>
                  </td>
                  <td class="p-1" width="10%">
                    <select class="w-100 form-select" formControlName="Target">
                      <option value="">Select</option>
                      @for (option of SectionQuestions.Fields; track option) {
                      @if (
                      option.UniqueID !=
                      Rows().controls[rowIndex].get("Source").value
                      ) {
                      <option [value]="option.UniqueID">
                        {{ option.Name | slice: 0 : 10
                        }}{{ option.Name.length > 10 ? "..." : "" }}
                      </option>
                      }
                      }
                    </select>
                  </td>
                  <td class="p-1" width="3%">
                    <input class="w-100" type="checkbox" formControlName="allowscore"
                      (change)="scoreChecked(rowIndex)" />
                  </td>
                  <td class="p-1" width="5%">
                    <input class="w-100 form-control" type="text" formControlName="score" />
                  </td>
                  <td class="p-1" width="35%">
                    <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                      [data]="otherSectionQuestions" formControlName="MQuestins">
                    </ng-multiselect-dropdown>
                  </td>
                  <td class="p-1" width="1.5%">
                    <i class="fas fa-trash" aria-hidden="true" title="Delete" (click)="deleteRow(rowIndex)"
                      style="color: red"></i>
                  </td>
                </tr>
              </tbody>
              }
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <div class="float-right">
            <button class="btn btn-primary" type="submit">Add</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #configureMdl let-modal>
  <div class="overflow-auto">
    <form [formGroup]="configureForm" (ngSubmit)="onSubmitConfigForm()">
      <div class="modal-content">
        <div class="modal-header">
          <span class="badge badge-danger p-2">
            {{ selectedNode.label }}
          </span>
        </div>
        <div class="modal-body">
          <div class="form-group row p-0 m-0">
            <div class="col-sm-4">
              <label>
                <input style="vertical-align: middle !important" type="checkbox" (change)="onMandatoryCheck()"
                  class="m-2" formControlName="mandatory" />
                <span>Mandatory</span>
              </label>
            </div>

            <div class="col-sm-4">
              <label>
                <input style="vertical-align: middle !important" type="checkbox" (change)="onConditionChange()"
                  class="m-2" formControlName="conditions" /><span>Conditions</span></label>
            </div>
            <div class="col-sm-4">
              <label for="2">
                <input style="vertical-align: middle !important" type="checkbox" name="isAllowScoring" value="14"
                  class="m-2" id="allowScore" formControlName="isAllowScoring" /><span>Allow Scoring</span>
              </label>
            </div>
          </div>

          <div class="form-row p-0 m-0">
            @if (configureForm.controls["conditions"].value) {
            <div class="form-group col-md-5" style="display: flex">
              <label for="selection" class="col-sm col-form-label">Selection :</label>
              <div class="col-md">
                <select class="mt-2 select-option" formControlName="selection">
                  <option>Select</option>
                  @for (option of optionsData; track option) {
                  <option [value]="option.UniqueID">
                    {{ option.OptionText }}
                  </option>
                  }
                </select>
              </div>
            </div>
            }

            <div class="form-group col-md-5" style="display: flex">
              <label for="staticEmail" class="col-sm col-form-label">Navigation To:</label>
              <div class="col-md">
                <select class="mt-2 select-option" formControlName="navigateTo">
                  <option disabled>Select</option>
                  @for (
                  element of AllQuestions;
                  track element;
                  let i = $index
                  ) {
                  <option [value]="element.UniqueID">
                    @if (element.Name != "") {
                    <span>{{ element.Name }}</span>
                    }
                    @if (element.Name == "") {
                    <span>{{ element.Label | slice: 0 : 10
                      }}{{ element.Label.length > 10 ? "..." : "" }}</span>
                    }
                  </option>
                  }
                </select>
              </div>
            </div>

            <div class="form-group col-md-2" style="display: flex">
              <button class="btn btn-primary add-btn" (click)="onOkMdl(false)">
                Add
              </button>
            </div>
          </div>
          @if (nodeRelations && nodeRelations.length > 0) {
          <div class="row">
            <div class="col-12">
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th class="th-column">Source</th>
                    <th class="th-column">Target</th>
                    <th class="th-column">Condition</th>
                    <th class="th-column">Score Value</th>
                    <th class="th-column">Dependent Questions</th>
                    <th class="th-column">Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (
                  nodeRelation of nodeRelations;
                  track nodeRelation;
                  let i = $index
                  ) {
                  <tr style="height: 40px !important">
                    <td>
                      {{ getNodeLabel(nodeRelation.source) | slice: 0 : 10
                      }}{{
                      getNodeLabel(nodeRelation.source).length > 10
                      ? "..."
                      : ""
                      }}
                    </td>
                    <td>
                      {{ getNodeLabel(nodeRelation.target) | slice: 0 : 10
                      }}{{
                      getNodeLabel(nodeRelation.target).length > 10
                      ? "..."
                      : ""
                      }}
                    </td>
                    <td>{{ nodeRelation.label }}</td>
                    <td>
                      <input [disabled]="
                              !configureForm.controls['isAllowScoring'].value
                            " [value]="nodeRelation.points" (blur)="onScoreEnter(i, $event, nodeRelation)"
                        type="number" step="1" onkeydown="return event.keyCode !== 190" min="-255" max="255" />
                    </td>
                    <td>
                      <div>
                        <form [formGroup]="form">
                          <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                            [data]="AllQuestions" formControlName="selectedItems_{{
                                  nodeRelation.id
                                }}" (onFilterChange)="onFilterChange()" (onDropDownClose)="onDropDownClose()"
                            (onSelect)="
                                  onItemSelect($event, nodeRelation, i)
                                " (onDeSelect)="
                                  onDeSelect($event, nodeRelation, i)
                                " (onSelectAll)="
                                  onSelectAll($event, nodeRelation, i)
                                " (onDeSelectAll)="
                                  onDeSelectAll($event, nodeRelation, i)
                                ">
                          </ng-multiselect-dropdown>
                        </form>
                      </div>
                    </td>
                    <td>
                      <i class="fas fa-trash" aria-hidden="true" title="Delete" (click)="removeLink(nodeRelation)"
                        style="color: red"></i>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          }
        </div>
        <div class="modal-footer">
          <div class="float-right">
            <input type="submit" (click)="onOkMdl(true)" value="Ok" class="btn btn-primary" />
            <input type="button" (click)="this.modalReference.close()" class="btn cancelBtn m-2" data-dismiss="modal"
              value="Cancel" />
          </div>
          <br />
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #infoModal let-modal>
  <div class="modal-content">
    <div class="modal-body">
      {{ messageData }}
    </div>
    <div class="modal-footer">
      <div class="float-right">
        <button (click)="closeModal()" class="btn btn-sm btn-primary">
          Ok
        </button>
      </div>
      <br />
    </div>
  </div>
</ng-template>

<ng-template #confirmationModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Delete Confirmation</h5>
      <button type="button" class="close" data-dismiss="modal" (click)="modalConfirmReference.close()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ ConfirmationMsg }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalConfirmReference.close()">
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="removeLinkConfirmation(linkToRemove, true)">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addLinkModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Dependent question</h5>
      <button type="button" class="close" data-dismiss="modal" (click)="modalAddLinkReference.close()"
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      @for (adddata of dropdownQuestions; track adddata; let i = $index) {
      <div>
      </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalAddLinkReference.close()">
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="addLinkConfirmation()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #JSONImportContent let-modal>
  <div class="overflow-auto">
    <form [formGroup]="importForm">
      <div class="modal-content">

        <div class="modal-body">
          <input type="file" multiple accept=".json,application/json" (change)="onFileImport($event)" />
          @if(uploadedFile?.length > 0) {
          <span>{{uploadedFile?.[0]?.name}} <a (click)="deleteUploadedFile()" title="Delete"><i
                class="fas fa-trash"></i></a></span>
          }
        </div>
        <div class="modal-footer">
          <div class="float-right">
            <input type="submit" (click)="onImportClick()" value="Import" class="btn btn-primary" />
            <input type="button" (click)="this.modalQuestionImportResponse.close()" class="btn cancelBtn m-2"
              data-dismiss="modal" value="Cancel" />
          </div>
          <br />
        </div>
      </div>
    </form>
  </div>
</ng-template>